import styled from "styled-components";

const Scrollable = styled.div`
    overflow: scroll;
    padding-bottom: 20px;
`;

export default Scrollable;